import React from 'react';
import { CardActions, CardContent, Typography } from '@mui/material';
import { AppButton, AppButtonProps } from './button/appButton';

interface AppCardContentProps {
  subTitle: string;
  details: (string | JSX.Element)[];
  buttons: AppButtonProps[];
}

const makeStyles = () => ({
  detail: {
    paddingBottom: '5px',
    display: 'block',
  },
  cardActions: {
    p: 0,
    marginTop: 'auto',
  },
});

export function AppCardContent({
  subTitle,
  details,
  buttons,
}: AppCardContentProps): JSX.Element {
  const style = makeStyles();

  return (
    <>
      <CardContent>
        {subTitle && <Typography variant="h6">{subTitle}</Typography>}
        {details.map((detail, index) => {
          const key = index + '';

          return (
            <Typography variant="body1" key={key} style={style.detail}>
              {detail}
            </Typography>
          );
        })}
      </CardContent>
      <CardActions sx={style.cardActions}>
        {buttons.map((button) => (
          <AppButton key={button.label} {...button} />
        ))}
      </CardActions>
    </>
  );
}
